import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
@Injectable({
  providedIn: 'root',
})
export class SettingsPermission {
  adminSettingModules: string[];
  constructor(private authService: AuthService) {
    this.adminSettingModules = [
      'locations',
      'terminals',
      'users',
      'settings',
      'notifications',
      'audit',
    ];
  }

  mapPermissions() {
    let mappedPermission = [];
    if (!this.authService.user) return [];
    this.authService.user.AccessRoles.forEach((item) => {
      if (
        this.adminSettingModules.indexOf(item.ModuleName.toLowerCase()) > -1
      ) {
        mappedPermission.push({
          ModuleName: item.ModuleName,
          CanView: item.View,
          CanEdit: item.Edit,
          CanAdd: item.Add,
          CanUpdate: item.Update,
          CanDelete: item.Delete,
        });
      }
    });
    return mappedPermission;
  }

  adminSettingModulesCanView() {
    return this.mapPermissions().filter((item) => {
      return item.CanView === true;
    });
  }

  canAccessAdminSettingMenu() {
    if (!this.authService.user) return false;
    return Number(this.authService.user.RoleId) === 1;
  }
}
